module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rev01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Praise for"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TO CATCH A HIGHLANDER")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot, are the ingredients in Hawkins’s utterly delightful tale.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Karen Hawkins’s best book to date! Fast, sensual, and brilliant, it tantalizes and pleases all in the same breath…. This is romance at its best!”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Romance and More!")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TO SCOTLAND, WITH LOVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Hawkins brings another hardheaded MacLean brother and a sassy miss together in a sensual battle of the sexes. Her humor, intelligent characters, and story are simply delightful.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HOW TO ABDUCT A HIGHLAND LORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Hawkins takes a fiery Scot lass and a wastrel lord and puts them together in a match made in, well, not heaven, but one that’s heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Abduct a Highland Lord,")]), _vm._v(" the characters are as wonderful as the story…. [It] is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—JoyfullyReviewed.com")])]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('p', {
    staticClass: "reviewPageSubhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("…and for all the delightfully sexy romances of Karen Hawkins")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Karen Hawkins knows how to keep a reader entranced from first page to last.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Joan Johnston")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Karen Hawkins never fails to please!”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Victoria Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Karen Hawkins writes fast, fun, and sexy stories!”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Christina Dodd")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“A lively, sexy escapade…”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Linda Howard")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Saucy, witty flirtation…excitement and passion.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Luscious, romantic, witty, sexy, and emotional.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Fast paced, lively, sexy, and laugh-out-loud funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Romance and More!")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“An enjoyable fast-paced read. The sensuality is steamy….”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—The Best Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“If you like your novels fast paced and full of laugh-out-loud fun, this is the one for you!”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_vm._v("—Romance Reviews Today")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“I laughed, cried, and fell in love…. Every character was so well written that they seemed as though they could jump right off the page….”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("—Fresh Fiction")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c510b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781439164341_rev01.vue
// module id = 57
// module chunks = 0